const getters = {
  processing: (state) => state.processing,
  bulkProcessing: (state) => state.bulkProcessing,
  invoices: (state) => state.invoices,
  showInvoices: (state) => state.showInvoices,
};

export default getters;
